import UserList from './UserList';
import UserEdit from './UserEdit';

export default {
  list: UserList,
  edit: UserEdit,
};
